import { render, staticRenderFns } from "./AddRelatedOrderModal.vue?vue&type=template&id=31788701&scoped=true&"
import script from "./AddRelatedOrderModal.vue?vue&type=script&lang=js&"
export * from "./AddRelatedOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31788701",
  null
  
)

export default component.exports